import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M18 16L8 6M19 13L11 5M18 8L16 6M16 18L6 8M13 19L5 11M8 18L6 16" strokeLinecap="round" />
	</SVG>
);
